// Forces a logged-in user with no firstName/lastName on their profile to fill it in
// before reaching any other page. Auth itself is still handled in app.vue.
export default defineNuxtRouteMiddleware(async (to) => {
	if (import.meta.server) return

	const name = String(to.name ?? '')
	if (PROFILE_GUARD_EXEMPT.includes(name)) return

	const userId = useAppCookie('userId')
	const token = useAppCookie('token')
	if (!userId.value || !token.value) return

	if (await checkProfileComplete()) return

	// the toast is raised by /profile/info itself, once it has rendered
	return navigateTo({
		path: '/profile/info',
		query: {next: to.fullPath},
	}, {replace: true})
})
